interface CookieOptions {
  days?: number;
  path?: string;
  secure?: boolean;
  sameSite?: "Lax" | "Strict" | "None";
  domain?: string;
}

function isProduction() {
  if (typeof window === "undefined") return false;
  return window.location.hostname.includes("idehnama.ir");
}

export function setCookie(name: string, value: string, opts: CookieOptions = {}) {
  if (typeof document === "undefined") return;

  deleteCookie(name);

  const prod = isProduction();
  const d = new Date();
  if (opts.days) d.setTime(d.getTime() + opts.days * 24 * 60 * 60 * 1000);

  const expires = opts.days ? `; expires=${d.toUTCString()}` : "";
  const path = `; path=${opts.path ?? "/"}`;
  const secure = prod || opts.secure ? "; Secure" : "";
  const sameSite = opts.sameSite ? `; SameSite=${opts.sameSite}` : "; SameSite=Lax";
  const domain = opts.domain !== undefined
    ? (opts.domain ? `; domain=${opts.domain}` : "")
    : prod ? "; domain=.idehnama.ir" : "";

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}${path}${domain}${secure}${sameSite}`;
}

export function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const cookies = document.cookie ? document.cookie.split("; ") : [];
  for (const cookie of cookies) {
    const [key, ...val] = cookie.split("=");
    if (decodeURIComponent(key) === name) {
      return decodeURIComponent(val.join("="));
    }
  }
  return null;
}

export function deleteCookie(name: string) {
  if (typeof document === "undefined") return;

  const enc = encodeURIComponent(name);
  const expired = "expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";

  document.cookie = `${enc}=; ${expired}; SameSite=Lax`;
  document.cookie = `${enc}=; ${expired}; SameSite=None`;
  document.cookie = `${enc}=; ${expired}; Secure; SameSite=Lax`;
  document.cookie = `${enc}=; ${expired}; domain=.idehnama.ir; SameSite=Lax`;
  document.cookie = `${enc}=; ${expired}; domain=.idehnama.ir; Secure; SameSite=Lax`;
  document.cookie = `${enc}=; ${expired}; domain=.idehnama.ir; Secure; SameSite=None`;
}
